window.info_spots = {}
window.info_spots_multi = {}
area_clicked = -1
init_spots = true
current_language_id = ''

$(document).ready ->

  current_language_id = $('#info_spot_language').val()

  try
    regex = new RegExp('=>', 'g')
    window.info_spots_multi = JSON.parse($('#spots_multi').val().replace(regex, ':'))
    window.info_spots = window.info_spots_multi[current_language_id] || {}
  catch
    window.info_spots_multi[current_language_id] = {}

  $('#openEditInfoSpots').click ->

    $('#editInfoSpotsModal').find(".upload-preview-ipad").find("img").attr('src', $(".crop-image-button:visible").siblings('.upload-preview-ipad').find("img").attr('src'))

    $(".upload-preview").removeClass "upload-preview"
    $(".upload-preview-ipad").addClass "upload-preview"

    if !!$('#spots').val()
      current_language_id = $('#info_spot_language').val()
      window.info_spots = window.info_spots_multi[current_language_id]
      regex = new RegExp('=>', 'g')
      coords = window.info_spots
      index = 0
      spots = []
      languages = Object.keys(coords)
      while languages.length > index
        spot = coords[languages[index]]
        spots[index] = {key: "#{index}", selected: true, toolTip: spot.text, isSelectable: true, isDeselectable: false}
        index++

      setTimeout (->
        createMap()#addSpots(spots)
        return
      ), 1000

      init_spots = false

    setTimeout (->
      $(document).ready ->
        $('#editInfoSpotsModal .canvas-container').find('#remove-spot').click()
        $('#editInfoSpotsModal .canvas-container').find('br').remove()
        $('#editInfoSpotsModal .canvas-container').find('canvas').remove()
        $('#editInfoSpotsModal .canvas-container').find('#remove-spot').remove()
        $('#editInfoSpotsModal .canvas-container').find('#text_for_info').remove()
        $('#editInfoSpotsModal .canvas-container').find('#add-spot').remove()
        if !!CKEDITOR.instances['text_for_info']
          setTimeout (->
            CKEDITOR.instances['text_for_info'].destroy(true)
            return
          ), 100

        $('.canvas-area').canvasAreaDraw({
          imageUrl: $('#photo').attr('src')
        });

        setTimeout (->
          CKEDITOR.replace( 'text_for_info' );
          addSpotCallback()
          return
        ), 200
      return
    ), 200
    
    return

  $('#info_spot_language').change ->
    window.info_spots_multi[current_language_id][area_clicked].text = CKEDITOR.instances['update_text'].getData()
    current_language_id = $('#info_spot_language').val()
    window.info_spots = window.info_spots_multi[current_language_id]
    createMap()
    CKEDITOR.instances['update_text'].setData(window.info_spots[area_clicked].text)
    
  return

addSpotCallback = ->
  $('.add-spot').click ->
    text_for_info = CKEDITOR.instances['text_for_info'].getData();
    if text_for_info != '' && $('#coords_for_info').val() != ''
      size = Object.keys(window.info_spots).length
      window.info_spots[size] = {text: text_for_info, coords: $('#coords_for_info').val()}
      current_language_id = $('#info_spot_language').val()
      size = Object.keys(window.info_spots_multi[current_language_id]).length - 1
      languages = Object.keys(window.info_spots_multi)
      index = 0
      while languages.length > index
        window.info_spots_multi[languages[index]][size] = {text: text_for_info, coords: $('#coords_for_info').val()}
        index++
      $('#editInfoSpotsModal .canvas-container').find('#remove-spot').click()
      CKEDITOR.instances['text_for_info'].setData('');
      $('#coords_for_info').val('')

      createMap()
        
      $('.preview-header-for-canvas').show()

createMap = () ->
  spots = []
  index = 0

  $('#chaptermap').html('')
  languages = Object.keys(window.info_spots)
  while languages.length > index
    coords = window.info_spots[languages[index]].coords.split(',').splice(0, 2).join()
    $('#chaptermap').append("<area name='area-#{index}' shape='circle' text='#{window.info_spots[languages[index]].text}' coords='#{coords},25' href='#'>")
    spots[index] = {key: "#{index}", selected: true, toolTip: window.info_spots[languages[index]].text, isSelectable: true, isDeselectable: false}
    index++

  addSpots(spots)

addSpots = (spots) ->
  background_color = if !!$('#background_color').val() then $('#background_color').val().replace('#', '') else 'ffffff'
  border_color = if !!$('#border_color').val() then $('#border_color').val().replace('#', '') else '000000'
  $('#photo').mapster({
    fill: !!$('#background_color').val()
    fillColor: background_color,
    fillOpacity: 0.3,
    stroke: true,
    strokeColor: border_color,
    strokeOpacity: 0.5,
    strokeWidth: 2,
    areas:  spots,
    showToolTip: true,
    scaleMap: false,
    toolTipContainer: "<div class='tooltipped'></div>",
  })
  updateContent()

updateContent = () ->
  $('area').click ->
    area_clicked = parseInt($(this).attr('data-mapster-key'))
    $('.update-container').show()
    CKEDITOR.replace( 'update_text' );
    CKEDITOR.instances['update_text'].setData($(this).attr('text'))
    
$('.update-container .update').click ->
  current_language_id = $('#info_spot_language').val()
  window.info_spots[area_clicked].text = CKEDITOR.instances['update_text'].getData()
  languages = Object.keys(window.info_spots_multi)
  index = 0
  while languages.length > index
    if current_language_id == languages[index]
      window.info_spots_multi[languages[index]][area_clicked].text = CKEDITOR.instances['update_text'].getData()
    index++
  CKEDITOR.instances['update_text'].setData('')
  area_clicked = -1
  createMap()
  $('.update-container').hide()
    
$('.update-container .delete').click ->
  if confirm('Are you sure?')
    current_language_id = $('#info_spot_language').val()
    languages = Object.keys(window.info_spots_multi)
    index = 0
    delete window.info_spots[area_clicked]
    while languages.length > index
      delete window.info_spots_multi[languages[index]][area_clicked]
      index++
    index = 0
    while languages.length > index
      i = 0
      keys = Object.keys(window.info_spots_multi[languages[index]])
      while keys.length > i
        window.info_spots_multi[languages[index]][i] = window.info_spots_multi[languages[index]][keys[i]]
        i++
      delete window.info_spots_multi[languages[index]][i]
      index++
    CKEDITOR.instances['update_text'].setData('')
    createMap()
    $('.update-container').hide()
    
$('.update-container .cancel').click ->
  CKEDITOR.instances['update_text'].setData('')
  $('.update-container').hide()
